export default "__VITE_ASSET__B5S_bsry__"